export const trailerTypes = [
  { id: "dry_van", text: "Dry Van" },
  { id: "reefer", text: "Reefer" },
  { id: "flatbed", text: "Flatbed" },
];

export const radiusTypes = [
  { id: "50", text: "50 mi" },
  { id: "100", text: "100 mi" },
  { id: "150", text: "150 mi" },
  { id: "250", text: "250 mi" },
];

export const defaultRadiusType = radiusTypes[2];

export const UserProfileTrailerTypes = {
  dry_van: trailerTypes[0],
  reefer: trailerTypes[1],
  flatbed: trailerTypes[2],
};

export const defaultTrailerType = trailerTypes[0];

export const ThemeTypes = {
  light: { id: "light", text: "Light" },
  dark: { id: "dark", text: "Dark" },
};

export const LanguageTypes = [
  { id: "english", text: "English" },
  { id: "spanish", text: "Spanish" },
  { id: "russian", text: "Russian" },
];

export const ComparisonValues = ["LOWESTPRICE", "LOWPRICE", "MEDIUMPRICE", "HIGHPRICE", "HIGHESTPRICE"];
